//this is the first this clients will see when opening web page
import React from "react";

const IndexToHomePage = () => {
    return (
        <div id="homepage-containter">
            <h1 id="homepage-text">Welcome to</h1>
            <h1 id="homepage-text">THE SWEET SPOT</h1>
            <p id="homepage-text2">Please login or register if not yet a user</p>
        </div>
    )
}

export default IndexToHomePage;
